import Rest from "../../../class/tool/Rest";
import Store from "./Store";

class StoreController {
    #_rest = new Rest();
    _callback = null;
    static _status = [
        {
            value: null,
            id: null
        },
        {
            value: "SARL",
            id: 4
        },
        {
            value: "EURL",
            id: 3
        },
        {
            value: "ME",
            id: 1
        },
        {
            value: "EI",
            id: 2
        },
        {
            value: "SASU",
            id: 5
        },
        {
            value: "SAS",
            id: 6
        },
        {
            value: "SA",
            id: 7
        },
        {
            value: "SNC",
            id: 8
        },
        {
            value: "SCS",
            id: 9
        },
        {
            value: "SCA",
            id: 10
        }
    ];
    static _rows = [
        {
            label: "Nom de la boutique",
            attribute: "name",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Nom",
            emptyText: "Aucun",
            readOnly: true,
            edit: false
        },
        {
            label: "Raison sociale",
            attribute: "socialReason",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "SIRET",
            attribute: "siret",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "TVA Intracommunautaire",
            attribute: "intraTva",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Code APE",
            attribute: "apeCode",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "RCS",
            attribute: "companyRegister",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Statut",
            attribute: "legalStatus",
            inputType: "select",
            returnType: "string",
            list: StoreController._status,
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Capital social",
            attribute: "shareCapital",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Adresse",
            attribute: "address",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Complément d'adresse",
            attribute: "additional",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Code postal",
            attribute: "postalCode",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        },
        {
            label: "Ville",
            attribute: "city",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "Ville",
            emptyText: "Aucun"
        },
        {
            label: "Pays",
            attribute: "country",
            inputType: "select",
            returnType: "string",
            list: [
                {
                    "value": "France",
                    "id": 1
                }
            ],
            dictionary: null,
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun"
        }
    ];

    static getRows() {
        const user = JSON.parse(localStorage.getItem("user"));
        let rows = [];
        let index = -1;
        let attributes = [];

        rows = StoreController._rows;
        attributes = [];

        for (let i in attributes) {
            index = rows.findIndex(_ => _.attribute === attributes[i]);

            if (index >= 0) {
                rows[index].readOnly = user.onlyHivy !== 1;
                rows[index].edit = user.onlyHivy === 1;
            }
        }

        return rows;
    }

    setFormValues(object, setValues) {
        setValues(prev => ({
            ...prev,
            name: object.name,
            socialReason: object.socialReason,
            address: object.address,
            additional: object.additional,
            postalCode: object.postalCode,
            city: object.city,
            country: object.country,
            siret: object.siret,
            intraTva: object.intraTva,
            apeCode: object.apeCode,
            companyRegister: object.companyRegister,
            legalStatus: object.legalStatus,
            shareCapital: object.shareCapital
        }));
    }
    returnUpdatesFromCompare(object, datas, compare = true) {
        // clean header & footer receipt
        if (datas.receiptHeader !== undefined) {
            if (typeof datas.receiptHeader !== "object")
                datas.receiptHeader = JSON.parse(datas.receiptHeader)

            let header = []

            for (let i = 0; i < datas.receiptHeader.length; i++) {
                if (datas.receiptHeader[i].text !== "") {
                    header.push(datas.receiptHeader[i])
                }
            }

            datas.receiptHeader = JSON.stringify(header)
        }
        if (datas.receiptFooter !== undefined) {
            if (typeof datas.receiptFooter !== "object")
                datas.receiptFooter = JSON.parse(datas.receiptFooter)

            let footer = []

            for (let i = 0; i < datas.receiptFooter.length; i++) {
                if (datas.receiptFooter[i].text !== "") {
                    footer.push(datas.receiptFooter[i])
                }
            }

            datas.receiptFooter = JSON.stringify(footer)
        }

        let dataKeys = Object.keys(datas)
        let key = ""
        let updates = {}

        for(let i in dataKeys) {
            key = dataKeys[i];

            if (datas[key] !== undefined) {
                if (compare) {
                    if (Reflect.get(object, key) !== datas[key] && datas[key] !== null && (datas[key].length > 0 || datas[key] >= 0))
                        Reflect.set(updates, key, datas[key]);
                }
                else {
                    if (datas[key] !== null)
                        Reflect.set(updates, key, datas[key]);
                }
            }
        }

        return updates
    }
    checkValues(object) {
        const params = [
            { name: "name", method: "checkName", val: object.name },
            { name: "label", method: "checkLabel", val: object.label },
            { name: "color", method: "checkColor", val: object.color },
            { name: "reference", method: "checkReference", val: object.reference },
            { name: "referenceProvider", method: "checkReferenceProvider", val: object.referenceProvider },
            { name: "provider", method: "checkProvider", val: object.provider_id },
            { name: "brand", method: "checkBrand", val: object.brand_id },
            { name: "category", method: "checkCategory", val: { id: object.category_id, type: object.category_type } },
            { name: "description", method: "checkDescription", val: object.description },
            { name: "nullStockTrigger", method: "checkNullStockTrigger", val: object.nullStockTrigger },
            { name: "printDescription", method: "checkPrintDescription", val: object.printDescription },
            { name: "soldOut", method: "checkSoldOut", val: object.soldOut },
            { name: "stockManagement", method: "checkStockManagement", val: object.stockManagement },
            { name: "stockThresholdTrigger", method: "checkStockThresholdTrigger", val: object.stockThresholdTrigger },
            { name: "unit", method: "checkUnit", val: object.unit },
            { name: "variablePrice", method: "checkVariablePrice", val: object.variablePrice }
        ];
        let errors = {};
        let method;

        for (let i in params) {
            method = StoreController[params[i].method];

            try { method.apply(null, params[i].val); }
            catch (e) { errors.params[i].name = e.message; }
        }

        if (Object.keys(errors).length > 0) throw new Error(JSON.stringify(errors));
        else return true;
    }
    buildSectors(sectors) {
        return JSON.parse(sectors)
    }

    index() {
        this.#_rest.sendQuery(
            'GET',
            '/stores',
            {},
            this.handleIndex);
    }
    handleIndex = (response, error, status) => {
        let listObjects = [];

        for(let item in response.data)
            listObjects.push(new Store(response.data[item]));

        if (this._callback !== null)
            this._callback(listObjects, error, status);
    }

    show(id) {
        this.#_rest.sendQuery(
            'GET',
            '/stores/' + id,
            {},
            this.handleShow)
    }
    handleShow = (response, error, status) => {
        const object = !error ? new Store(response.data) : null

        if (this._callback !== null)
            this._callback(object, error, status)
    }

    put(object, datas) {
        this.#_rest.sendQuery(
            'PUT',
            '/stores/' + object.id,
            datas,
            this.handlePut);
    }
    handlePut = (response, error, status) => {
        if (this._callback !== null)
            this._callback(response, error, status);
    }
}

export default StoreController;